import Vue from 'vue'
import VueRouter from 'vue-router'
import HomeView from '../views/HomeView.vue'

Vue.use(VueRouter)

const routes = [
  {
    path: '/',
    name: 'default',
    redirect: "/home"
  },
  {
    path: '/home',
    name: 'home',
    component: HomeView,

  },
  {
    path: '/error',
    name: 'error',
    meta: {
      title: '错误'
    },
    component: () => import(`@/views/ErrorView.vue`)
  },
  {
    path: '/message',
    name: 'message',
    meta: {
      title: '消息'
    },
    component: () => import(`@/pages/MessageView.vue`)
  },
]

const router = new VueRouter({
  routes
})

export default router

